import React, { Suspense, lazy } from "react";
import {Navigate, Route, Routes} from "react-router-dom";
import classes from "./App.module.css";

const Home = lazy(() => import("./pages/Home/Home"));
const Booking = lazy(() => import("./components/Booking/Booking"));
const PriceList = lazy(() => import("./pages/PriceList/PriceList"));
const AboutUs = lazy(() => import("./pages/AboutUs/AboutUs"));
const Policy = lazy(() => import("./pages/Policy/Policy"));
const ContactUs = lazy(() => import("./pages/ContactUs/ContactUs"));

function App() {
    /* NOTE:
     * Solution for redirecting to 404 not found page
     * When hosting static static single page application and
     * go to hcl.com/abcxyc and refresh it will return 404 page not found
     * because it's a static single page application the hosting only know hcl.com
     * so we config for the host to know we're using static single page application
     * In Netlify for Example. We redirect to the index.html when we make request to the server
     * https://stackoverflow.com/questions/27928372/react-router-urls-dont-work-when-refreshing-or-writing-manually/44467274#44467274
     * */
    return (
        <div className={classes.App}>
            <Suspense fallback={null}>
                <Routes>
                    <Route path="*" element={<Navigate to="/" replace/>}/>
                    <Route exact path="/" element={<Home/>}/>
                    <Route path="/booking" element={<Booking/>}/>
                    <Route path="/services" element={<PriceList/>}/>
                    <Route path="/about-us" element={<AboutUs/>}/>
                    <Route path="/policy" element={<Policy/>}/>
                    <Route path="/contact-us" element={<ContactUs/>}/>
                </Routes>
            </Suspense>
        </div>
    );
}

export default App;
